import script from "./MapHeatmap.vue?vue&type=script&setup=true&lang=js"
export * from "./MapHeatmap.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__